import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {ScrollToConfigOptions, ScrollToService} from '@nicky-lenaers/ngx-scroll-to';

@Component({
  selector: 'app-view-profile',
  templateUrl: './view-profile.component.html',
  styleUrls: ['./view-profile.component.css']
})
export class ViewProfileComponent implements OnInit {
  pack: any;

  constructor(private route:Router,private scrollToService: ScrollToService,) {
    this.pack=JSON.parse(localStorage.getItem('package'))

  }

  ngOnInit(): void {
    console.log(this.pack)
    this.triggerScrollTo();
  }

    book() {
     this.route.navigate(['/index-booking']);
    }

  triggerScrollTo() {

    const config: ScrollToConfigOptions = {
      target: 'home'
    };

    this.scrollToService.scrollTo(config);
  }
}
